<ion-content class="ion-padding" fullscreen="">
  <!-- Centered layout container -->
  <ion-grid class=" w-100 d-flex justify-content-center align-items-center main-row ">
    <ion-row class="w-100">
      <!-- Left section: application logo -->
      <ion-col size="12" size-md="12" size-xl="6" class="logo_head d-flex ion-justify-content-center ion-text-lg-right">

        <img class="logo-img" src="assets/imgs/logo-with-bottom-tagline.png" alt="logo" />
      </ion-col>

      <!-- Right section: authentication forms -->
      <ion-col size="12" size-md="12" size-xl="6" class="main_form_section ion-text-center ion-text-lg-left mt-4">

        <div class="main_login">
          <!-- Routed authentication views -->
          <router-outlet></router-outlet>

          <!-- App store links (web-only) -->
          @if (!isMobileApp) {
          <div class="d-flex justify-content-center w-100 gap-3 mt-5">
            <a [href]="iOSAppUrl" target="_blank" rel="noopener noreferrer">
              <img class="img-width" src="assets/imgs/app-store.png" alt="app-store" />
            </a>

            <a [href]="playStoreUrl" target="_blank" rel="noopener noreferrer">
              <img class="img-width" src="assets/imgs/play-store.png" alt="play-store" />
            </a>
          </div>
          }
        </div>
      </ion-col>

    </ion-row>
  </ion-grid>
</ion-content>